export const ACCESS_TOKEN_NAME = "AccessToken";
export const REFRESH_TOKEN_NAME = "RefreshToken";
